module.exports = __webpack_public_path__ + "img/graph_vetor_green.63d7a19f.svg";